import { render, staticRenderFns } from "./VueMarquee.vue?vue&type=template&id=c79360e6&"
import script from "./VueMarquee.vue?vue&type=script&lang=js&"
export * from "./VueMarquee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports